export default {
    current: 1,
    pageSize: 10,
    pageSizeOptions: ["10", "20", "30"],
    showTotal: (total, range) => {
        return `共 ${total} 条，显示第 ${range[0]} ~ ${range[1]} 条`
    },
    showQuickJumper: true,
    showSizeChanger: true,
    total: 0,
}